export enum CustomThemes {
  Default = 'default',
  Dark = 'dark',
}
